/**
 * Created by lari on 12/06/2017.
 */
(function () {
  'use strict';
  
  angular
    .module('vcutils.zipcode')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcutilszipcode', {
        url: '/vcutilszipcode',
        views: {
          'playgroundmain@playground': {
            template: `<h3><tt>&lt;zipcode zip="" city=""&gt;</tt></h3><div ui-view="zipcodeview"></div>`
          }
        },
        onEnter: function () {
          console.log('playground.vcutilszipcode entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcutilszipcode.allcomponents', {
        url: '/allcomponents',
        resolve: {
          zip: function () {
            return '';
          },
          city: function () {
            return '';
          },
          onchange: function () {
            return function () {
              console.log('debug: dummy onchange called for zipcode');
            };
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'zipcodeview@playground.vcutilszipcode': {
            component: 'zipcode',
            bindings: {
              zip: 'zip',
              city: 'city'
            }
          }
        },
        onEnter: function () {
          $log.debug('playground.vcutilszipcode.allcomponents entered');
        }
      });

  }// all routes
}());
